<div class="spinner-wrapper" *ngIf="show">
  <div class="lds-dual-ring">
    <div></div>
  </div>
  <div class="spinner-text" *ngIf="showSpinnerText">{{ 'Spinner.Loading' | translate:lang }}</div>
</div>
